/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import * as Config from "./config";
//import { useSelector } from "react-redux";

async function reqCMSBienesBanner(token) {
  const API_URI_BIENES_BANNER = Config.rutas.bienesBanner;
  try {
    const response = await axios.get(API_URI_BIENES_BANNER, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqCMSSucursales() {
  const API_URI_SUCURSALES = Config.rutas.sucursales;
  try {
    const response = await axios.get(API_URI_SUCURSALES);
    return response.data.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqCMSConvenios() {
  const API_URI_CONVENIOS = Config.rutas.convenios;
  try {
    const response = await axios.get(API_URI_CONVENIOS);
    return response.data.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqHistoria() {
  const API_URI_HISTORIA = Config.rutas.historia;
  try {
    const response = await axios.get(API_URI_HISTORIA);
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqCMSDelegados() {
  const API_URI_DELEGADOS = Config.rutas.delegados;
  try {
    const response = await axios.get(API_URI_DELEGADOS);
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqServiahorro(token) {
  const API_URI_SERVIAHORRO = Config.rutas.serviahorro;
  try {
    const response = await axios.get(API_URI_SERVIAHORRO, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqCMSInversiones(token) {
  const API_URI_INVERSIONES = Config.rutas.inversiones;
  try {
    const response = await axios.get(API_URI_INVERSIONES, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqPlanesAsistencia(token) {
  const API_URI_PLANES_ASISTENCIA = Config.rutas.planesAsistencia;
  try {
    const response = await axios.get(API_URI_PLANES_ASISTENCIA, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqAllCreditos() {
  const API_URI_CREDITOS =
    Config.rutas.apiCMSUri +
    "?query={tipoCreditoPersonal {beneficios codigoAgencia codigoProducto codigoSubaplicacion condicioines descripcion displayText imageUrl moneda requisitos sector snippetFormularioEloqua tipoCredito}}";
  try {
    const response = await axios.get(API_URI_CREDITOS);
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqCMSAfiliacion(token) {
  const API_URI_AFILIACION = Config.rutas.afiliacion;
  try {
    const response = await axios.get(API_URI_AFILIACION, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqOrganizacion(token) {
  const API_URI_ORGANIZACION = Config.rutas.organizacion;
  try {
    const response = await axios.get(API_URI_ORGANIZACION, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqCalcularCredito(data) {
  const API_URI_BASE = Config.rutas.calculadoraCredito;
  const PARAMS =
    "codigoProducto=" +
    data.codigoProducto +
    "&codigoSubaplicacion=" +
    data.codigoSubaplicacion +
    "&plazo=" +
    data.plazo +
    "&monto=" +
    data.monto +
    "&moneda=" +
    data.moneda +
    "&sector=" +
    data.sector +
    "&codigoAgencia=" +
    data.codigoAgencia;
  const API_URI_CALC = API_URI_BASE + PARAMS;
  try {
    const response = await axios.get(API_URI_CALC, {
      headers: { ApiKey: Config.apikey },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqCreditosPersonales(token) {
  const API_URI_CREDITOS_PERSONALES = Config.rutas.creditosPersonales;
  try {
    const response = await axios.get(API_URI_CREDITOS_PERSONALES, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqCreditosHipotecarios(token) {
  const API_URI_CREDITOS_HIPOTECARIOS = Config.rutas.creditosHipotecarios;
  try {
    const response = await axios.get(API_URI_CREDITOS_HIPOTECARIOS, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqCreditosProductivos(token) {
  const API_URI_CREDITOS_PRODUCTIVOS = Config.rutas.CreditosProductivos;
  try {
    const response = await axios.get(API_URI_CREDITOS_PRODUCTIVOS, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqAhorrosProgramados(token) {
  const API_URI_AHORROS_PROGRAMADOS = Config.rutas.ahorrosProgramados;
  try {
    const response = await axios.get(API_URI_AHORROS_PROGRAMADOS, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqTarjetas(token) {
  const API_URI_TARJETAS = Config.rutas.tarjetas;
  try {
    const response = await axios.get(API_URI_TARJETAS, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqTipsDeSeguridad(token) {
  const API_URI_TIPS_SEGURIDAD = Config.rutas.tipsDeSeguridad;
  try {
    const response = await axios.get(API_URI_TIPS_SEGURIDAD, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqFirmaDigital(token) {
  const API_URI_FIRMA_DIGITAL = Config.rutas.firmaDigital;
  try {
    const response = await axios.get(API_URI_FIRMA_DIGITAL, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqReglamentos(token) {
  const API_URI_REGLAMENTO = Config.rutas.reglamentos;
  try {
    const response = await axios.get(API_URI_REGLAMENTO, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqPromociones(token) {
  const API_URI_PROMOCIONES = Config.rutas.promociones;
  try {
    const response = await axios.get(API_URI_PROMOCIONES, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqResumeBanner(token) {
  const API_URI_RESUME_BANNER = Config.rutas.resumeBanner;
  try {
    const response = await axios.get(API_URI_RESUME_BANNER, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqComunicadosOficiales(token) {
  const API_URI_COMUNICADOS = Config.rutas.comunicadosOficiales;
  try {
    const response = await axios.get(API_URI_COMUNICADOS, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqGestionPagos(token) {
  const API_URI_GESTION_PAGOS = Config.rutas.gestionPagos;
  try {
    const response = await axios.get(API_URI_GESTION_PAGOS, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export default {
  reqCMSBienesBanner,
  reqCMSSucursales,
  reqCMSConvenios,
  reqHistoria,
  reqCMSDelegados,
  reqServiahorro,
  reqCMSInversiones,
  reqPlanesAsistencia,
  reqAllCreditos,
  reqCMSAfiliacion,
  reqOrganizacion,
  reqCalcularCredito,
  reqCreditosPersonales,
  reqCreditosHipotecarios,
  reqCreditosProductivos,
  reqAhorrosProgramados,
  reqTarjetas,
  reqTipsDeSeguridad,
  reqFirmaDigital,
  reqReglamentos,
  reqPromociones,
  reqResumeBanner,
  reqComunicadosOficiales,
  reqGestionPagos
};
